import React, { Component } from 'react'
import i18next from './config'
import { I18nextProvider, withTranslation } from 'react-i18next'

interface WithTransProps {
  language?: string
}

export function withTrans<P extends object>(WrappedComponent: React.ComponentType<P & WithTransProps>) {
  const TranslatedComponent = withTranslation()(WrappedComponent)

  return class extends Component<P> {
    render() {
      return (
        <I18nextProvider i18n={i18next}>
          <TranslatedComponent {...this.props} language={(i18next as any).language} />
        </I18nextProvider>
      )
    }
  }
} 